import React, { ReactNode } from 'react'
import { DialogProps, Dialog, DialogTitle, DialogContent, DialogActions, Typography, makeStyles } from '@material-ui/core'
import { Button, ButtonCategory, Spinner } from 'components'
import { useLocalization } from 'components/methods'
import { Color } from 'theme/style'
import CloseIcon from '@material-ui/icons/Close'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  dialog: {
    width: '700px',
    maxWidth: '95%',
    [theme.breakpoints.down('sm')]: {
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      maxHeight: 'calc(100vh - ' + theme.spacing(1) + ')',
      margin: theme.spacing(1) + ' !important',
    }
  },
  content: {
    zIndex: 1
  },
  title: {
    textAlign: 'center',
  },
  description: {
    marginTop: theme.spacing(1),
    color: Color.TextSecondary,
    textAlign: 'center'
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  overlay: {
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    zIndex: 10,
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  close: {
    position: 'absolute',
    top: 10,
    right: 10,
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  closeIcon: {
    width: '24px',
    height: '24px',
    color: Color.TextDisabled
  },
}))


export interface CustomDialogProps extends DialogProps {
  description?: string | React.ReactNode
  confirmText?: string
  confirmButtonCategory?: ButtonCategory
  confirmButtonTint?: string
  actions?: React.ReactNode
  onConfirm?: () => void
  onClose?: () => void
  children?: ReactNode
  isConfirming?: boolean
}


const CustomDialog = ({ ...props }: CustomDialogProps) => {
  const classes = useStyles()
  const { t } = useLocalization()

  function handleClose() {
    if (props.onClose != null) props.onClose()
  }

  const confirmDialog = () => {
    // handleClose()
    if (props.onConfirm != null) props.onConfirm()
  }

  return (
    <>
      <Dialog open={props.open} onClose={props.onClose} classes={{ paper: clsx(classes.dialog, props.className) }}>
        <div className={classes.close} onClick={handleClose}><CloseIcon className={classes.closeIcon} /></div>

        <DialogTitle>
          {props.title != null && <Typography className={classes.title} component="h2" variant="h2">{props.title}</Typography>}
          {props.description != null && <Typography className={classes.description} component="p" variant="body1">{props.description}</Typography>}
        </DialogTitle>
        <DialogContent>
          {props.isConfirming === true && <div className={classes.overlay}><Spinner /></div>}
          <div className={classes.content}>
            {props.children}
          </div>
        </DialogContent>
        <DialogActions className={classes.actions}>
          {props.actions}
          {props.onConfirm != null &&
            <Button category={props.confirmButtonCategory ?? 'confirm'} prominent={true} onClick={confirmDialog} tint={props.confirmButtonTint}>{props.confirmText ?? t('GEL.whitelabel.common.confirm')}</Button>
          }
        </DialogActions>
      </Dialog>
    </>
  )
}

export default CustomDialog
